import $ from 'jquery'; 
const Dispatcher = require('./../Dispatcher');
const Constants = require('./../Constants');

const NewsActions = {
  openPanel: () => {
    Dispatcher.dispatch({
      actionType: Constants.ACTION_OPEN_NEWS
    });
  },

  closePanel: () => {
    Dispatcher.dispatch({
      actionType: Constants.ACTION_CLOSE_NEWS
    });
  },

  closeViaMask: (event) => {
    if ($(event.target).hasClass('mask')) {
      Dispatcher.dispatch({
        actionType: Constants.ACTION_CLOSE_NEWS
      });
    }
  }
};

export default NewsActions;
